<template>
  <b-nav-item-dropdown ref="notification-dropdown" class="dropdown-notification mr-25" menu-class="dropdown-menu-media" right @show="onShow">
    <template #button-content>
      <i class="fa-solid fa-heart-pulse text-danger" style="font-size: 20px;"></i>
    </template>
  </b-nav-item-dropdown>
</template>

<script>


import { mapActions } from 'vuex'

export default {
  name:"MonitoringToggler",
  data:()=>({
    unreadMessagesCount:0,
    checkUnreadMessagesInterval:null,
  }),
  created() {
    this.checkUnreadMessages();
    this.checkUnreadMessagesInterval = setInterval(()=>{
      this.checkUnreadMessages();
    },30*1000);
  },
  beforeDestroy() {
    clearInterval(this.checkUnreadMessagesInterval);
  },
  computed:{

  },
  methods: {
    ...mapActions('chat', ['fetchUnreadMessagesCount','getChatMessages']),
    onShow() {
      this.$emit('show');
      this.checkUnreadMessages();
      this.$router.push({ name: 'monitoring' });
    },
    checkUnreadMessages() {
      this.fetchUnreadMessagesCount().then(count=>{
        this.unreadMessagesCount = count.total;
      });
    }
  }
}
</script>

<style>

</style>
